const myEnv = process.env

/*
functions permettant l'appel au serveur node local pour effectuer
 - les lectures des repertoires locaux
 - les appels à nakala (CORS)
 - le resultat est toujours sous la forme
    retour.reponse (variable de forme string, objet suivant les cas)
    retour.erreur (vide si pas d'erreur et le texte de l'erreur sinon)
*/

const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT

const url_base_zotero = myEnv.REACT_APP_URL_BASE_ZOTERO
const api_version_zotero = myEnv.REACT_APP_URL_BASE_ZOTERO
const key_zotero = myEnv.REACT_APP_KEY_ZOTERO

const url_base_geonames = myEnv.REACT_APP_URL_BASE_GEONAMES
const user_geonames = myEnv.REACT_APP_USER_GEONAMES

const url_base_opentheso = myEnv.REACT_APP_URL_BASE_OPENTHESO

const apiIGLS = `${protocole}${host}:${port}`


//console.log("API")

const elements = [
    'inscription'
    ,'donnee'
    ,'document'
    ,'auteur'
    ,'collection'
    ,'action'
    ,'user'
]

const axios = require('axios')

export const apiGetZoteroItemsByCritere = async (critere, filtre="everything") => {

    //"?includeTrashed=0&sort=title&direction=asc&format=json&qmode=everything&q=Aliquot
    const parameters = "?"
        + "includeTrashed=0"
        + "&sort=title"
        + "&direction=asc"
        + "&format=json"
        //+ "&qmode=" + filtre
        + "&q=" + critere

    const headers = {
        'accept': 'application/json',
        'zotero-api-version' : api_version_zotero,
    }
    let retour = {};
    await axios({
        method: 'get',
        url: url_base_zotero + parameters,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiReferenceZoteroFormateeById = async (id) => {

    const headers = {
        'accept': 'application/json',
        'zotero-api-key': key_zotero,
        'zotero-api-version' : api_version_zotero,
    }
    const parameters = "?"
    + "format=bib"
    + "&style=http://www.zotero.org/styles/chicago-fullnote-bibliography-fr"

    let retour = {};
    await axios({
        method: 'get',
        url: url_base_zotero + "/" + id + parameters,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}


export const apiListeElements = async (typeElement,limit=25, index=0) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiIGLS}/${typeElement}/limit/${limit}/index/${index}`
    const headers = {
        'accept': 'application/json',
    }
    console.log("Je cherche les elements de type " + typeElement + " de " + index + " par " + limit)
    await axios({
        method: 'get',
        url: baseurl,

        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiSearchElements = async (typeElement, critere=null, typeDocument=null, limit=25, index=0) => {
    //Affichage avec un elemnt de recherche

    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossible de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiIGLS}/${typeElement}/limit/${limit}/index/${index}`
    const headers = {
        'accept': 'application/json',
    }
    //console.log("Je cherche les elements de type " + typeElement + " avec le critere " + critere)
    //console.log("Base url " + baseurl)
    const element = {
        body: {
            critere: critere,
            typeDocument: typeDocument
        }
    }
    //console.log("recherche API")
    //console.log(element)

    await axios({
        method: 'post',
        url: baseurl,
        headers: headers,
        data: element
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiListe = async (typeElement, critere) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossible de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiIGLS}/${typeElement}/critere/${critere}`
    const headers = {
        'accept': 'application/json',
    }
    //console.log("Je cherche les elements de type " + typeElement + " avec le critere " + critere)
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}


export const apiElementImage = async (id, typeImage) => {
    let retour = {}
    if (! id || id === "undefined"){
        return retour
    }

    //image standard
    let responseType = "blob"
    //cas image svg
    if (typeImage.indexOf('svg') !== -1){
        responseType = "text"
    }

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const baseurl = `${apiIGLS}/donnee/file/${id}`
    const headers = {
        'accept': 'application/json',
        'x-access-token': token,
    }
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
        responseType: responseType
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        if (error.response.status === 403) {
            alert("Vous n'étes pas autorisé à visualiser ce contenu")
            retour.reponse = null
        } else {
            retour.erreur = error.response ? error.response.statusText : error.message
            console.log(error)
        }
    })
    return retour
}

export const apiElementById = async (typeElement, id) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    //console.log("Je cherche element de type " + typeElement + " " + id)
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossible de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }
    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const baseurl = `${apiIGLS}/${typeElement}/${id}`
    const headers = {
        'accept': 'application/json',
        'x-access-token': token
    }
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        if (error.response.status === 403) {
            alert("Vous n'étes pas autorisé à visualiser ce contenu")
            retour.reponse = null
        } else {
            retour.erreur = error.response ? error.response.statusText : error.message
            console.log(error)
        }
    })
    return retour
}

export const apiCreeElement = async(typeElement, element) => {
    let retour = {}

    const baseurl = `${apiIGLS}/${typeElement}`
    const headers = {
        'accept': 'application/json',
    }
    await axios({
        method: 'post',
        url: baseurl,
        headers: headers,
        body: element
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}


//critere sous la forme (nomParam=param&)
export const apiElementByCritere = async(typeElement, critere) => {
    let retour = {}

    const baseurl = `${apiIGLS}/${typeElement}/critere/`
    const headers = {
        'accept': 'application/json',
    }

    await axios({
        method: 'get',
        url: baseurl,
        params: critere,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error + " requete base " + JSON.stringify(critere))
    })
    return retour
}


//recherche des elements du référentiel
//requete sur un groupe avec un critere
export const apiVocByCritere = async (critere, theso="4", group="MT92") => {
    let retour = {}
    //group=${group}
    const baseurl = `${url_base_opentheso}autocomplete/${critere}?theso=${theso}&lang=fr&group=${group}&format=full`
    const headers = {
        'Accept': 'application/json',
    }

    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        console.log(reponse)
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        retour.reponse = []
        console.log(error + " requete base " + baseurl)
    })
    return retour
}

//recherche des elements du référentiel
//requete sur un groupe avec un critere
export const apiPaysByCritereByContinent = async (critere, continentCode="EU") => {
    let retour = {}
    const baseurl = `${url_base_geonames}search?name_startsWith=${critere}`
    + `&continentCode=${continentCode}&featureCode=PCLI&username=${user_geonames}&type=json`

    console.log("critere " + critere)
    console.log("continent " + continentCode)
    const headers = {
        'Accept': 'application/json',
    }

   await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error + " requete base " + baseurl)
    })
    return (retour)
}

export const apiLocaliteByCritereByPays = async (critere, pays) => {
    let retour = {}
    const paramPays = (typeof pays === 'string') ? `&country=${pays}` :""
    const baseurl = `${url_base_geonames}search?name_startsWith=${critere}`
        + "&featureClass=A&featureClass=P"
        + paramPays
        + `&username=${user_geonames}&type=json`

    //console.log("Base URL gonames " + baseurl)
    const headers = {
        'Accept': 'application/json',
    }
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error + " requete base " + baseurl)
    })
    return retour
}

export const apiLocaliteById = async (geonameId) => {
    let retour = {}
    const baseurl = `${url_base_geonames}get?geonameId=${geonameId}`
        + `&username=${user_geonames}`
    //const optionsXML = {ignoreComment: true, alwaysChildren: true}
    //console.log("Base URL gonames " + baseurl)
    const headers = {
        'Accept': 'application/json',
    }
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error + " requete base " + baseurl)
    })
    return retour
}